import { render, staticRenderFns } from "./CompareRack.vue?vue&type=template&id=a5047bbc&"
import script from "./CompareRack.vue?vue&type=script&lang=js&"
export * from "./CompareRack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports